<template>
  <div id="main-wrapper">
    <div v-if="loadingState.isLoading" class="global-loading-overlay"></div>
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { borrarDatosSessionStorage } from "./utils/Session";
import AccionesDataService from './services/AccionesDataService';
import imageAlert from "@/assets/images/clock.svg";
import Swal from 'sweetalert2';
import { loadingState } from './services/LoadingState';

let abortController = new AbortController();

export default {
  name: "App",
  data: () => ({
    logueado: false,
    mostrandoAlerta: false,
    inactivityTimer: null,
    responseTimer: null,
    INACTIVITY_LIMIT: 1800000, // 30 minutos
    RESPONSE_LIMIT: 10,
  }),
  computed: {
    ...mapGetters(["isConnected"]),
    loadingState() {
      return loadingState;
    },
  },
  mounted() {
    globalThis.addEventListener("storage", this.verificarSesion);

    ["mousemove", "keydown", "click", "scroll", "touchstart"].forEach((evento) =>
      globalThis.addEventListener(evento, this.reiniciarTemporizador)
    );

    document.addEventListener("visibilitychange", this.onVisibilityChange);

    if (!sessionStorage.getItem("ultima_actividad")) {
      sessionStorage.setItem("ultima_actividad", Date.now());
    }

    if (sessionStorage.getItem("inactividad_mostrar_modal") === "true") {
      this.RESPONSE_LIMIT = sessionStorage.getItem('contador');
      globalThis.document.title = `ACIQUI [¡ATENCIÓN! ${this.RESPONSE_LIMIT}]`;
      this.renderizarModal();
    }
  },
  beforeUnmount() {
    ["mousemove", "keydown", "click", "scroll", "touchstart"].forEach((evento) =>
      globalThis.removeEventListener(evento, this.reiniciarTemporizador)
    );
    globalThis.removeEventListener("storage", this.verificarSesion);
    document.removeEventListener("visibilitychange", this.onVisibilityChange);
    clearTimeout(this.inactivityTimer);
  },
  created() {
    globalThis.__nprogressLoading = this.isLoading;
  },
  methods: {
    async verificarSesion() {
      if (sessionStorage.getItem("token")) {
        if (!this.logueado) {
          this.logueado = true;
          this.reiniciarTemporizador();
        }
      } else {
        this.logueado = false;
        clearTimeout(this.inactivityTimer);
      }
    },

    reiniciarTemporizador() {
      if (!this.logueado || this.mostrandoAlerta) return;

      //Guardar timestamp de última actividads
      sessionStorage.setItem("ultima_actividad", Date.now());

      if (this.inactivityTimer) clearTimeout(this.inactivityTimer);
      this.inactivityTimer = setTimeout(this.renderizarModal, this.INACTIVITY_LIMIT);
    },

    renderizarModal() {
      if (this.mostrandoAlerta) return;

      this.mostrandoAlerta = true;
      sessionStorage.setItem("inactividad_mostrar_modal", "true");
      clearTimeout(this.inactivityTimer);

      Swal.fire({
        title: "Cierre de sesión automático",
        text: "Por seguridad, se finalizará la sesión del usuario debido a inactividad en los últimos 30 minutos.",
        imageUrl: imageAlert,
        imageWidth: 100,
        imageHeight: 100,
        showConfirmButton: true,
        confirmButtonText: `Permanecer (${this.RESPONSE_LIMIT} seg)`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        reverseButtons: true,
        customClass: {
          popup: "custom-popup-class",
          confirmButton: "custom-confirm-button",
          title: "myCustom-popup-title",
          htmlContainer: "myCustom-popup-container",
        },
        didOpen: () => {
          const confirmButton = Swal.getConfirmButton();

          this.responseTimer = setInterval(() => {
            this.RESPONSE_LIMIT--;
            confirmButton.textContent = this.RESPONSE_LIMIT > 0
              ? `Permanecer (${this.RESPONSE_LIMIT} seg)`
              : "¡La sesión se cerrará automáticamente!";
            globalThis.document.title = `ACIQUI [¡ATENCIÓN! ${this.RESPONSE_LIMIT}]`;
            sessionStorage.setItem('contador', this.RESPONSE_LIMIT);

            if (this.RESPONSE_LIMIT === 0) {
              clearInterval(this.responseTimer);
              this.cerrarSesion();
            }
          }, 1000);
        },
      }).then(() => {
        clearTimeout(this.inactivityTimer);
        clearInterval(this.responseTimer);
        this.RESPONSE_LIMIT = 10;
        this.mostrandoAlerta = false;
        sessionStorage.removeItem("inactividad_mostrar_modal");
        globalThis.document.title = 'ACIQUI';
        this.reiniciarTemporizador();
      });
    },

    async cerrarSesion() {
      
      //Cancela TODAS las peticiones pendientes
      abortController.abort();
      abortController = new AbortController(); // crear uno nuevo para futuras sesiones

      clearTimeout(this.inactivityTimer);
      clearInterval(this.responseTimer);
      let userSession = JSON.parse(sessionStorage.getItem("usuarioLogueado"));
      if (userSession !== null) {
        await this.registrarConfiguracionBitacora(userSession);
      }
      this.logueado = false;
      this.mostrandoAlerta = false;



      globalThis.document.title = 'ACIQUI';
      this.RESPONSE_LIMIT = 10;
    },

    async registrarConfiguracionBitacora(userSession) {
      try {
        const data = {
          usuario: userSession,
          accion: 'Cierre de sesión por inactividad' + sessionStorage.infoDevice,
          fechaCreacion: new Date(),
          tipo: "accion",
        };
        const key = sessionStorage.getItem('key');
        const response = await AccionesDataService.create(data, key);
        if (response.status === 201) {
          globalThis.location = '/';
          borrarDatosSessionStorage();
        }
      } catch (error) {
        console.error(error);
      }
    },

    cambiar() {
      this.user = !this.user
      sessionStorage.setItem('user_', this.user);
    },

    onVisibilityChange() {
      if (document.visibilityState === 'visible') {
        const ultimaActividad = Number.parseInt(sessionStorage.getItem("ultima_actividad"), 10);
        const ahora = Date.now();
        const tiempoPasado = ahora - ultimaActividad;

        if (tiempoPasado >= this.INACTIVITY_LIMIT + this.RESPONSE_LIMIT * 1000) {
          this.cerrarSesion();

        } else if (tiempoPasado >= this.INACTIVITY_LIMIT) {
          this.renderizarModal();
        } else {
          this.reiniciarTemporizador();
        }
      }
    },

  },// END Methods
  watch: {
    "$route"() {
      this.verificarSesion();
    },
  },
};
</script>

<style>
.custom-popup-class {
  border-radius: 20px;
  background-color: #032e85;
  color: white;
  width: 400px;
}

.custom-confirm-button {
  font-size: 16px !important;
  font-weight: bold !important;
  padding: 10px 20px !important;
  border-radius: 8px !important;
  background-color: #ff6600 !important;
  color: #212121 !important;
}

.myCustom-popup-container {
  text-align: justify !important;
}

.myCustom-popup-title {
  font-size: 25px;
  text-align: center !important;
}

.global-loading-overlay {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(1px);
}

.spinner-icon {
  width: 50px;
  height: 50px;
  border: 5px solid white;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
